import type {PlaceId} from '@jetbrains/teamcity-ui'
import pluginRegistry from '@jetbrains/teamcity-ui/plugin/registry'
import {useEffect, useState} from 'react'

function usePluginWrapper(placeId: PlaceId) {
  const [hasPlugins, setHasPlugins] = useState(false)

  useEffect(() => {
    const updateRegistryHandler = () => {
      const plugins = pluginRegistry.searchByPlaceId(placeId)

      setHasPlugins(Array.isArray(plugins) ? plugins.length > 0 : plugins != null)
    }

    updateRegistryHandler()

    pluginRegistry.subscribe(updateRegistryHandler)
    return () => pluginRegistry.unsubscribe(updateRegistryHandler)
  }, [placeId])

  return {hasPlugins}
}

export default usePluginWrapper
